import { createVitalDurationMetric } from '@funtech-int/yango-shared';

export const playerMovieFirstFrame = createVitalDurationMetric('SLI.Player.Movie.FirstFrame');

export const playerChannelFirstFrame = createVitalDurationMetric('SLI.Player.Channel.FirstFrame');

export const playerTrailerFirstFrame = createVitalDurationMetric('SLI.Player.Trailer.FirstFrame');

export const playerBackgroundFirstFrame = createVitalDurationMetric(
    'SLI.Player.Background.FirstFrame'
);
